export enum ButtonPropsBorderRadius {
  Small = 5,
  Large = 51
}
